import { Link } from "react-router-dom";
import ArrowRightIcon from "../../icons/arrowRightIcon";
import { useTranslation } from "react-i18next";

const Tips = () => {
  const { t } = useTranslation();
  return (
    <article className="h-[600px] lg:h-[480px] relative py-10">
      <img
        src="/assets/shipping.png"
        alt="Shipping"
        className="absolute top-0 left-0 object-cover w-full h-full"
      />
      <div className="relative z-10 flex flex-col items-center justify-center w-11/12 h-full gap-2 mx-auto lg:justify-between lg:flex-row ">
        <section className="order-2 space-y-4 text-white lg:order-1">
          <h2 className="text-[32px] font-semibold">{t("lookingForTips?")}</h2>
          <p className="text-lg font-medium max-w-[480px]">
            {t("learnAboutChallenges")}
          </p>
          <Link className="px-5  py-4 bg-white rounded-lg text-mainBlue flex items-center gap-2 font-bold w-[230px] text-xl justify-center arrow-link">
            <span>{t("findMore")}</span>
            <span className="rtl:rotate-180 arrow">
              <ArrowRightIcon />
            </span>
          </Link>
        </section>
        <section className="order-1 lg:order-2">
          <img src="/assets/shipping2.png" alt="Shipping2" />
        </section>
      </div>
    </article>
  );
};

export default Tips;
